module.exports = {
    BASE_API:"/api/",
    PROXY_HOST:"http://erp-api.kube-test.cbestcd.com/"
}